import { trpc } from "../trpc";

/**
 * Delete a folder in a different account the current user is a member of.
 * Used by the Folder Picker Modal to let users remove a newly-created folder
 * before committing the copy. Caller must pass descendant-chain ids in
 * `childFolderIds` (deepest-first) so the BFF can cascade-delete — the org
 * service rejects folders with children.
 */
export function useDeleteFolderInTargetAccount() {
  const utils = trpc.useUtils();

  const mutation = trpc.folder.deleteFolderInTargetAccount.useMutation({
    onSettled: (_data, _error, variables) => {
      utils.folder.listFoldersForTargetAccount.invalidate({
        targetAccountId: variables.targetAccountId,
      });
    },
  });

  return {
    deleteFolderInTargetAccount: mutation.mutateAsync,
    isDeleting: mutation.isPending,
    error: mutation.error,
  };
}
